(function () {
    'use strict';

    var tracking = cylindo.getModule('tracking') || {};

    var BehaviorTracking = function (opts) {
        var self = this;

        var network = cylindo.getModule('cylindo.core.network');
        var settings = cylindo.getModule('cylindo.core.config');
        var pubsub = cylindo.getModule('cylindo.util.pubsub').create();
        var util = cylindo.getModule('cylindo.core.util');

        var framesHandler = opts.framesHandler;

        var urls = settings.get('urls');
        var trackingIFrameClass = '__cylindo_tracking';
        var internalSeq = 0;
        var eventQueue = [];
        var clientData = {};
        var keepAliveRangeKey = null;
        var keepAliveTimerID = null;
        var maxKeepAliveTime = 1800000; 
        var keepAliveTimeoutTimerID = null;
        var iframe = null;
        var eventCallbacks = [];
        var disableTracking = false;
        var domLoadingTime;
        var trackerValues = framesHandler.getTrackerValues(opts);
        var mode = trackerValues && trackerValues.MODE >= 0 && trackerValues.MODE <= 4 ?
            trackerValues.MODE : 1;
        var startFrame = trackerValues.START_FRAME || 1;
        var alternateContent = trackerValues.ALTERNATE_CONTENT || 0;
        var ar = trackerValues.AR || false;

        var comparisonFlags = {
            NoSpace: 0x1,
            NoDash: 0x2,
            Containing: 0x4,
            CaseSensitive: 0x8,
            All: 0xff,
            None: 0
        };

        var addToCartFilterOptions = {
            elementsSelector: 'button, a',
            attributes: [
                {
                    name: 'title',
                    values: ['addtocart', 'addcart', 'comprar'],
                    options: comparisonFlags.NoSpace | comparisonFlags.Containing
                },
                {
                    name: 'id',
                    values: ['addtocart', 'addcart', 'comprar'],
                    options: comparisonFlags.NoDash | comparisonFlags.Containing
                }
            ]
        };
        opts = opts || {};

        this.on = pubsub.on;
        this.trigger = pubsub.trigger;
        this.off = pubsub.off;
        this.data = {
            loaded: false,
            userID: null, 
            userSessionID: null, 
            viewerContainer: null,
            instanceID: 0
        };

        this.injectAddToCartTracking = opts.injectAddToCartTracking;

        this.get = get;
        this.destroy = destroy;
        this.track = track;
        this.updateProductCode = updateProductCode;
        this.getElapsedTime = getElapsedTime;
        this.setTimerID = setTimerID;
        this.bindTrackingEvent = bindTrackingEvent;
        this.renderTrackingFrame = renderTrackingFrame;
        this.disableTracking = function (flag) {
            disableTracking = flag;
        };

        init(opts.pid, opts.cid, opts.sku, opts.features, opts.configurationAlias, opts.container, opts.injectAddToCartTracking);

        function init(pid, cid, sku, features, configurationAlias, container, injectAddToCartTracking) {
            var elapsedTime;

            if (self.data.instanceID) {
                self.destroy();
            }

            self.data.instanceID = ++BehaviorTracking.counter;
            if (window.performance && window.performance.timing) {
                try {
                    domLoadingTime = window.top.performance.timing.domLoading;
                }
                catch (e) {
                    domLoadingTime = window.performance.timing.domLoading;
                }
                if (!domLoadingTime ||
                    domLoadingTime < 0) {
                    domLoadingTime = Date.now();
                }
            }
            else {
                domLoadingTime = Date.now();
            }

            self.data.viewerContainer = container;
            self.viewerContainer = document.getElementById(container);

            setOrRefreshKeepAliveTimeout(maxKeepAliveTime);

            elapsedTime = Date.now() - domLoadingTime;

            clientData.timestamp = domLoadingTime; 
            clientData.elapse = elapsedTime;
            clientData.clientID = cid;
            clientData.productID = pid;
            clientData.sku = sku;
            clientData.configurationAlias = configurationAlias || '';
            clientData.features = (features && features.join('*').toUpperCase()) || '';
            clientData.swidth = screen.width;
            clientData.sheight = screen.height;
        }
        /**
         * Renders tracking frame by url
         * Creates a DOM element with atrributes
         * Attach events for message handling
         */
        function renderTrackingFrame() {
            var trackingFrameUrl = network.resolveProtocol(urls.TRACKING_PAGE) +
                '?ts=' + Date.now() + '#' + window.location.href.split(/[?#]/)[0];
            var trackingFrame = document.createElement('iframe');

            trackingFrame.className = trackingIFrameClass;
            trackingFrame.setAttribute('src', trackingFrameUrl);
            trackingFrame.setAttribute('frameborder', '0');
            trackingFrame.setAttribute('title', trackingIFrameClass);
            trackingFrame.style.width = '0';
            trackingFrame.style.height = '0';
            trackingFrame.style.float = 'left';
            iframe = trackingFrame;

            if (document.addEventListener) {
                window.addEventListener('message', receiveMessage, false);
            }
            else if (document.attachEvent) { 
                window.attachEvent('onmessage', receiveMessage);
            }

            self.viewerContainer.appendChild(trackingFrame);

            createEvents();

            if (self.injectAddToCartTracking) {
                bindToCartButtons();
            }
        }

        function receiveMessage(event) {
            self.get();
            var regex = /(cylindev.com)|(bugtest.it)|(cylindo.com)|(localhost)|(bs-local)|(\*)/g;
            var iframeData = null;
            if (regex.test(event.origin)) {
                try {
                    iframeData = JSON.parse(event.data);
                }
                catch (e) {
                    return;
                }

                if (iframeData.hasOwnProperty('guid') && iframeData.hasOwnProperty('sid')) {
                    clientData.guid = self.data.userID = iframeData.guid;
                    clientData.sid = self.data.userSessionID = iframeData.sid;
                    self.trigger(self.events.LOADED);
                }
            }
        }

        /**
         * Returns a timestamp of the elapsed time since the tracker was created.
         * @return {number} timestamp
         */
        function getElapsedTime() {
            return (Date.now() - domLoadingTime);
        }

        /**
         * Establish an identifier for a timer interval.
         * @param {number} id 
         */
        function setTimerID(id) {
            if (keepAliveTimerID) {
                clearInterval(keepAliveTimerID);
            }
            keepAliveTimerID = id;
        }
        /**
         * Destroy element and remove related data.
         */
        function destroy() {
            if (document.removeEventListener) {
                window.removeEventListener('message', receiveMessage, false);
            }
            else if (document.detachEvent) { 
                window.detachEvent('onmessage', receiveMessage);
            }
            if (iframe) {
                if (iframe.parentElement) {
                    iframe.parentElement.removeChild(iframe);
                }
                iframe = null;
            }
            cancelKeepAliveTimer();
            cancelKeepAliveTimeoutTimer();
            if (pubsub && typeof pubsub.destroy === 'function') {
                pubsub.destroy();
            }
        }

        /**
         * Returns the tracking iframe element.
         * @return {DOMObject|null}
         */
        function get() {
            var tempFrameElement = null;

            if (iframe) {
                return iframe;
            }

            tempFrameElement = document.querySelectorAll('.' + trackingIFrameClass);

            if (tempFrameElement.length) {
                iframe = tempFrameElement[0];
            }

            return iframe || null;
        }

        /**
         * Tracking function to prepare the event data for saving.
         * @param {number} event 
         * @param {Object} data 
         */
        function track(event, data, cb) {
            var viewerTrackingData;
            if (disableTracking) {
                return;
            }
            internalSeq++;
            viewerTrackingData = {
                t: Date.now(),
                e: event,
                s: internalSeq,
                d: data,
                c: cb || null
            };
            if (!self.data.loaded) {
                eventQueue.push(viewerTrackingData);
                return;
            }
            saveEvent(viewerTrackingData);
        }

        /**
         * Attaches an event handler to a DOM element.
         * @param {DOMObject} el The element to bind to
         * @param {string} type The event to listen for
         * @param {number} event The event ID to be tracked
         * @param {function} getData Returns an object for the event tracker
         */
        function bindTrackingEvent(el, type, event, getData) {
            var fn = function () {
                this.track(event, getData());
            };
            if (!eventCallbacks[event]) {
                eventCallbacks[event] = [];
            }
            eventCallbacks[event].push(fn);
            if (document.addEventListener) {
                el.addEventListener(type, fn, false);
            }
            else if (document.attachEvent) {
                el.attachEvent('on' + type, fn);
            }
            else {
                el['on' + type] = fn;
            }
        }

        function unbindTrackingEvent(el, type, event) {
            var fns = null;
            var i;
            var fnsLen;

            if (eventCallbacks[event]) {
                fns = eventCallbacks[event];
            }
            if (fns && fns.length) {
                fnsLen = fns.length;
                for (i = 0; i < fnsLen; i++) {
                    if (document.removeEventListener) {
                        el.removeEventListener(type, fns[i], false);
                    }
                    else if (document.detachEvent) {
                        el.detachEvent('on' + type, fns[i]);
                    }
                    else {
                        el['on' + type] = null;
                    }
                }
                eventCallbacks[event] = [];
            }
        }

        function saveEvent(eventData) {
            var metadata = settings.get('metadata');
            var url, eventSaved;
            var dataToBeTracked = {
                Guid: clientData.guid,
                Version: metadata.TRACKING_MSG_VERSION,
                SessionID: clientData.sid,
                ClientID: clientData.clientID,
                ProductID: clientData.productID,
                PageID: clientData.timestamp,
                InstanceID: self.getInstanceID(),
                Elapse: eventData.t - clientData.timestamp,
                Seq: eventData.s,
                Sku: clientData.sku,
                EventType: eventData.e || 1,
                Data: JSON.stringify(eventData.d) || {}
            };
            if (eventData && eventData.e == 10) {
                dataToBeTracked.Range = keepAliveRangeKey;
            }
            if (eventData.e != 10) {
                url = network.resolveProtocol(urls.TRACKING_SERVICES_BASE + 'add');
                network.doTracking(url,
                    function (response) {
                        eventSaved = true;
                        if (eventData.c) {
                            eventData.c(eventSaved);
                        }
                    },
                    {
                        type: 'POST',
                        data: dataToBeTracked
                    },
                    function () {
                        if (eventData.c) {
                            eventSaved = false;
                            eventData.c(eventSaved);
                        }
                    }
                );
            }
            else {
                url = network.resolveProtocol(urls.TRACKING_SERVICES_BASE + 'keepalive');
                network.doTracking(url,
                    function (data) {
                        keepAliveRangeKey = data;
                    },
                    {
                        type: 'POST',
                        data: dataToBeTracked
                    },
                    null
                );
            }
        }

        function onLoaded() {
            var metadata = settings.get('metadata');
            var eqLength = eventQueue.length;
            var i;
            var toTrack;
            self.data.loaded = true;
            toTrack = {
                't': domLoadingTime,
                'et': Date.now() - domLoadingTime,
                'ua': navigator.userAgent,
                'screen': [screen.width, screen.height],
                'locale': navigator.language || navigator.userLanguage,
                'vv': metadata.VERSION,
                'if': window.location !== window.parent.location,
                'features': clientData.configurationAlias || clientData.features,
                'pro': window.location.protocol ? window.location.protocol : 'file:',
                'host': window.location.hostname ? window.location.hostname : 'localhost',
                'port': (window.location.port ? window.location.port : ''),
                'path': window.location.pathname,
                'fr': startFrame,
                'm': mode,
                'ac': alternateContent,
            };
            if (ar) {
                toTrack.ar = true;
            }
            self.track(self.trackingEvents.PAGE_LOAD, toTrack);

            for (i = 0; i < eqLength; i++) {
                saveEvent(eventQueue[i]);
            }
            eventQueue = [];
        }

        function createEvents() {
            self.get();
            self.on(self.events.LOADED, onLoaded);
        }

        function setOrRefreshKeepAliveTimeout(time) {
            if (!keepAliveTimeoutTimerID) {
                setTimeout(function () {
                    keepAliveTimeoutTimerID = null;
                    cancelKeepAliveTimer();
                }, time);

            }
            else {
                cancelKeepAliveTimeoutTimer();
                setOrRefreshKeepAliveTimeout(time);
            }
        }

        function cancelKeepAliveTimeoutTimer() {
            if (keepAliveTimeoutTimerID) {
                clearTimeout(keepAliveTimeoutTimerID);
                keepAliveTimeoutTimerID = null;
            }
        }
        function cancelKeepAliveTimer() {
            if (keepAliveTimerID) {
                clearInterval(keepAliveTimerID);
                keepAliveTimerID = null;
            }
        }

        function bindToCartButtons() {
            var addToCartButtons = getFilteredElements(addToCartFilterOptions);

            var len = addToCartButtons.length;
            var i;

            for (i = 0; i < len; i++) {
                self.bindTrackingEvent(addToCartButtons[i], 'click', self.trackingEvents.UNSAFE_ADD_TO_CART, getProductDataCallback);
            }
        }

        function unbindToCartButtons() {
            var addToCartButtons = getFilteredElements(addToCartFilterOptions);
            var len = addToCartButtons.length;
            var i;

            for (i = 0; i < len; i++) {
                self.unbindTrackingEvent(addToCartButtons[i], 'click', self.trackingEvents.UNSAFE_ADD_TO_CART);
            }
        }

        function getProductDataCallback() {
            var quantityFilterOptions = {
                elementsSelector: 'input:text',
                attributes: [
                    { name: 'title', values: ['quantity', 'qty'], options: comparisonFlags.NoSpace },
                    { name: 'id', values: ['quantity', 'qty'], options: comparisonFlags.NoDash }
                ]
            };
            var quantityFields = getFilteredElements(quantityFilterOptions);
            var priceFilterOptions = {
                elementsSelector: 'span, div',
                attributes: [
                    { name: 'title', values: ['price', 'precio'], options: comparisonFlags.NoSpace },
                    { name: 'id', values: ['price', 'precio'], options: comparisonFlags.NoDash },
                    { name: 'class', values: ['price', 'precio'], options: comparisonFlags.NoDash },
                    { name: 'itemprop', values: ['price', 'precio'], options: comparisonFlags.NoDash }
                ]
            };
            var priceTags = getFilteredElements(priceFilterOptions);

            var price = -1;
            var currency = '';
            var priceText = priceTags.first().text();
            var quantity = quantityFields.first().val() || -1;

            if (priceText) {
                price = Number(priceText.replace(/[^0-9\.]+/g, ''));

                currency = priceText.replace(/[0-9\.]+/g, '');
            }

            currency = currency || 'USD';

            return {
                price: price,
                currency: currency,
                quantity: quantity,
                features: clientData.features
            };
        }

        function getFilteredElements(filterOptions) {

            var allElements = Array.prototype.slice.call(document.querySelectorAll(filterOptions.elementsSelector));
            var elementsFound = allElements.filter(function (element) {
                var i;
                for (i = 0; i < filterOptions.attributes.length; i++) {
                    if (checkAttributeMatch(element, filterOptions.attributes[i])) {
                        return true;
                    }
                }
                return false;
            });

            return (elementsFound ? elementsFound : []);
        }

        function checkAttributeMatch(elem, attr) {

            var value = elem.getAttribute(attr.name);
            var spaceRegex;
            var dashRegex;
            var replaceRegex;
            var attrValuesLen;
            var regexParam;
            var i;
            if (value) {
                spaceRegex = (attr.options & comparisonFlags.NoSpace) && /\s/ || '';
                dashRegex = (attr.options & comparisonFlags.NoDash) && /\-/ || '';

                replaceRegex = null;
                if (spaceRegex || dashRegex) {
                    regexParam = '[' + (spaceRegex && spaceRegex.source) + (dashRegex && dashRegex.source) + ']';
                    replaceRegex = new RegExp(regexParam, 'g');
                }

                if (replaceRegex) {
                    value = value.replace(replaceRegex, '');
                }

                if (!(attr.options & comparisonFlags.CaseSensitive)) {
                    value = value.toLowerCase();
                }

                if (!(attr.options & comparisonFlags.Containing)) {
                    if (attr.values.indexOf(value) > -1) {
                        return true;
                    }
                }
                else {
                    attrValuesLen = attr.values.length;
                    for (i = 0; i < attrValuesLen; i++) {
                        if (attr.values[i].indexOf(value) > -1) {
                            return true;
                        }
                    }
                }
            }

            return false;
        }
        function updateProductCode(productCode) {
            opts.sku = productCode;
            clientData.sku = productCode;
        }
    };

    BehaviorTracking.prototype.trackingEvents = {
        PAGE_LOAD: 1,
        FEATURE_CHANGED: 2,
        ZOOM_ACTIVATED: 3,
        ZOOM_DEACTIVATED: 4,
        ZOOM: 5,
        ADD_TO_CART: 6,
        UNSAFE_ADD_TO_CART: 7,
        ENTER_FULLSCREEN: 8,
        EXIT_FULLSCREEN: 9,
        KEEP_ALIVE: 10,
        SPIN: 11,
        SPIN_READY: 12,
        THUMB_CLICK: 13,
        ROOM_SCENE_VIEW: 14,
        UNKNOWN_FEATURES: 15,
        CHECKOUT_CONFIRMATION: 16,
        FEATURES_CANCELED: 17,
        UPDATE_TIMECHECK: 18,
        NOT_CREATED: 19,
        ALTERNATE_IMAGE_THUMB_CLICK: 20,
        ALTERNATE_IMAGE_ZOOM: 21,
        ALTERNATE_IMAGE_ZOOM_DEACTIVATED: 22,
        STYLESHOT_IMAGE_ZOOM: 23,
        STYLESHOT_IMAGE_ZOOM_DEACTIVATED: 24,
        STYLESHOT_READY: 25,
        STYLESHOT_THUMB_READY: 26,
        CUSTOM_IMAGE_SHOW: 27,
        CUSTOM_IMAGE_HIDE: 28,
        THUMBS_CHANGED: 29,
        THUMBS_SCROLL: 30,
        DOWNLOAD_COMPLETE: 31,
        NEXT_IMAGE: 32,
        PREVIOUS_IMAGE: 33,
        AR_VIEW_ACTIVATED: 34,
        AR_VIEW_DEACTIVATED: 35, 
        AR_INIT_FAILED: 36 
    };

    BehaviorTracking.counter = 0;

    BehaviorTracking.prototype.events = {
        LOADED: 'tracking.loaded'
    };

    BehaviorTracking.prototype.getInstanceID = function () {
        return this.data.instanceID;
    };

    BehaviorTracking.prototype.checkout = function (items, totalPrice, currency) {
        var itemsArrLen = items.length;
        var data;
        var i;

        for (i = 0; i < itemsArrLen; i++) {
            switch (typeof items[i].features) {
                case 'string':
                    break;
                case 'object':
                    if (typeof items[i].features.push === 'function') {
                        items[i].features = items[i].features.join('*');
                    }
                    else {
                        throw new Error('The features property should be either an array or a string!');
                    }
                    break;
                default:
                    items[i].features = '*';
                    break;
            }
            items[i].features = items[i].features ? items[i].features : '*';
            items[i].features = items[i].features.toUpperCase();
        }

        data = {
            items: items,
            total_price: totalPrice,
            currency: currency
        };

        this.track(this.clientID, this.trackingEvents.CHECKOUT_CONFIRMATION, data);
    };

    BehaviorTracking.prototype.getItem = function (sku, quantity, price, org_price, features) {
        return {
            sku: sku,
            quantity: quantity,
            price: price,
            org_price: org_price,
            features: features.join('*')
        };
    };

    BehaviorTracking.prototype.bindToCheckoutButton = function (el, getData) {
        this.bindTrackingEvent(this.clientID, el, 'click', this.trackingEvents.CHECKOUT_CONFIRMATION, getData);
    };

    tracking.behavior = {};
    tracking.behavior.create = function (opts) {
        return new BehaviorTracking(opts);
    };

    cylindo.addModule('tracking', tracking, true);
}).call(this);